import { createAction } from '@reduxjs/toolkit';

import { errorHandler } from 'services/axiosService';
import { AppThunkDispatch } from '../store';
import { QTaskComment } from 'data/models/Activity';
import { deleteTaskCommentApi, getTaskCommentsApi, postTaskCommentApi } from 'data/data-layer/qtask';

const UPDATE_TASK_COMMENTS = 'UPDATE_TASK_COMMENTS';
const CREATE_TASK_COMMENT = 'CREATE_TASK_COMMENT';
const DELETE_TASK_COMMENT = 'DELETE_TASK_COMMENT';
const TASK_COMMENTS_LOADING = 'TASK_COMMENTS_LOADING';

export const updateTaskCommentsOnState = createAction<QTaskComment[]>(UPDATE_TASK_COMMENTS);
export const addTaskCommentToState = createAction<QTaskComment>(CREATE_TASK_COMMENT);
export const removeTaskCommentFromState = createAction<string>(DELETE_TASK_COMMENT);
export const setTaskCommentLoading = createAction<boolean>(TASK_COMMENTS_LOADING);

export const getTaskComments =
  (taskId: number) =>
  async (dispatch: AppThunkDispatch): Promise<QTaskComment[] | undefined> => {
    dispatch(setTaskCommentLoading(true));
    try {
      const comments = await getTaskCommentsApi(taskId);
      dispatch(updateTaskCommentsOnState(comments));
      return comments;
    } catch (error) {
      await errorHandler(dispatch, 'Failed to fetch task comments')(error);
      return undefined;
    } finally {
      dispatch(setTaskCommentLoading(false));
    }
  };

export const createTaskComment =
  (comment: QTaskComment) =>
  async (dispatch: AppThunkDispatch): Promise<QTaskComment | undefined> => {
    dispatch(setTaskCommentLoading(true));
    try {
      const createdComment = await postTaskCommentApi(comment);
      dispatch(addTaskCommentToState(createdComment));
      return createdComment;
    } catch (error) {
      await errorHandler(dispatch, 'Failed to create a comment')(error);
      return undefined;
    } finally {
      dispatch(setTaskCommentLoading(false));
    }
  };

export const deleteTaskComment = (commentId: string) => async (dispatch: AppThunkDispatch) => {
  dispatch(setTaskCommentLoading(true));
  try {
    await deleteTaskCommentApi(commentId);
    dispatch(removeTaskCommentFromState(commentId));
  } catch (error) {
    await errorHandler(dispatch, 'Failed to delete a comment')(error);
  } finally {
    dispatch(setTaskCommentLoading(false));
  }
};
